module.exports = __webpack_public_path__ + "static/aniol-4c3ef36f9a574f7c926aed61ae54c823.jpg";